module.exports = __webpack_public_path__ + "img/flash.392d0918.png";